// removed by extract-text-webpack-plugin
module.exports = {"utilitary-link":"UtilitaryLink__utilitary-link___3eNT1"};